import { useQuery } from "@tanstack/react-query";

import { fetchCurrentAuthUser } from "../service";
import type { AuthUser } from "../types";

export const currentAuthUserQueryKey = ["auth", "current-user"] as const;

/** 获取当前登录用户资料，统一复用 /auth/me 登录态。 */
export function useCurrentAuthUser() {
  return useQuery<AuthUser>({
    queryKey: currentAuthUserQueryKey,
    queryFn: fetchCurrentAuthUser,
    staleTime: 60_000,
  });
}
